import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { ManageModelsComponent } from './manage-models.component';

export const ManageModels = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ManageModelsComponent as any
) as unknown as typeof ManageModelsComponent;
